module.exports = __webpack_public_path__ + "static/about_wide-b7e9d919a8cc392427e2e9204d1f29d9.jpg";